import { useEffect } from 'react'
import useSWRMutation from 'swr/mutation'
import { fetcher } from '@/utils/fetcher.js'
import { LOGIN_PATH } from '@/utils/authSession.js'

const SESSION_PROBE_URL = '/api/order/current'

/**
 * Probe for an existing cookie session. On success redirect to home.
 * Used on public entry pages (start, sign-in). 401 does not run global logout.
 */
export function useRedirectIfSession (homePath = '/en/user') {
  const { trigger, data, error, isMutating } = useSWRMutation(SESSION_PROBE_URL, fetcher)

  useEffect(() => {
    trigger({
      method: 'GET',
      skipGlobal401Handling: true
    })
  }, [trigger])

  useEffect(() => {
    if (data?.success === true) {
      window.location.replace(homePath)
    }
  }, [data, homePath])

  const probing = isMutating || (!data && !error)
  return { probing }
}

/**
 * Require a valid session for auth-only shells. 401 redirects to sign-in (no server logout).
 */
export function useRequireAuthSession () {
  const { trigger, data, error, isMutating } = useSWRMutation(SESSION_PROBE_URL, fetcher)

  useEffect(() => {
    trigger({
      method: 'GET',
      skipGlobal401Handling: true
    })
  }, [trigger])

  useEffect(() => {
    if (error?.status === 'Unauthorized') {
      window.location.replace(LOGIN_PATH)
    }
  }, [error])

  const sessionDenied = error?.status === 'Unauthorized'
  const allowed = data?.success === true || Boolean(error && !sessionDenied)
  const probing = isMutating || (!data && !error)
  return { allowed, probing }
}
